export const normalizeCategoryName = (category = {}) =>
	(category?.name || "").toLowerCase().replace(/\s+/g, " ").trim();

export const isHospitalCategory = (category = {}) => normalizeCategoryName(category) === "hospital";

/** Clinic / family doctor (primary care) — segment category from registration ("I'm a …"). */
export const isClinicCategory = (category = {}) => {
	const name = normalizeCategoryName(category);
	if (name === "clinic") return true;
	if (name === "family doctor" || name === "family physician") return true;
	if (name === "family medicine" || name === "family practice") return true;
	return name.includes("family") && (name.includes("doctor") || name.includes("physician"));
};

export const isPhysicianOrderCategory = (category = {}) =>
	isClinicCategory(category) || isHospitalCategory(category);

export const isPharmacyCategory = (category = {}) => normalizeCategoryName(category) === "pharmacy";
export const isLabCategory = (category = {}) => (category?.name || "").toLowerCase() === "lab";
export const isDiagnosticCategory = (category = {}) => (category?.name || "").toLowerCase() === "diagnostic";
export const isWellnessCategory = (category = {}) => (category?.name || "").toLowerCase() === "wellness";
